/**
 * Path of DAO model source files
 */
exports.MODEL_SOURCE_PATH = 'server/models';

/**
 * Path of migration scripting files
 */
exports.SCRIPT_SOURCE_PATH = 'server/scripts';

/**
 * Path of oolong schema files
 */
exports.DSL_SOURCE_PATH = 'oolong';

/**
 * Path of reversely generated oolong schema files
 */
exports.DSL_OUTPUT_PATH = 'oolong';

/**
 * Path of generated DAO model source files
 */
exports.MODEL_OUTPUT_PATH = 'src/models';

/**
 * Path of generated migration scripting files
 */
exports.SCRIPT_OUTPUT_PATH = 'src/scripts';

/**
 * Path of generated manifest files, e.g. API gateway config
 */
exports.MANIFEST_OUTPUT_PATH = 'conf';
